<template>
  <pl-modal :visible="showAuthentication" @close="closeDialog" max-width="400px">
    <div slot="header">Аутентификация</div>
    <div slot="content">
      <v-layout align-center style="min-height: 120px">
        <v-flex xs6 style="display: flex; justify-content: center">
          <v-icon :color="colorFingerIcon" class="finger-icon">fingerprint</v-icon>
        </v-flex>

        <v-flex v-show="!getFingerPrint" style="position: absolute">
          <preloader :size="50" />
        </v-flex>

        <v-flex v-if="!getFingerPrint" xs6> Приложите палец для аутентификации пользователя </v-flex>
        <v-flex v-else xs6>
          <span> {{ getEmployerName(activeEmployer) }}</span>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex>
          <v-flex>
            <v-autocomplete
              label="Подразделение"
              :items="units"
              item-value="id"
              item-text="name"
              v-model="localUnit"
              class="pl-autocomplete"
              browser-autocomplete="off"
              hide-no-data
              @change="changeUnit"
            />
          </v-flex>
        </v-flex>
      </v-layout>
    </div>
    <v-layout slot="footer" align-center justify-end row fill-height>
      <v-btn class="pl-btn pl-btn_default" @click="refreshFingerprints"> Обновить отпечатки </v-btn>
      <v-btn class="pl-btn pl-btn_default" @click="closeDialog">
        <v-icon left>clear</v-icon>
        Закрыть
      </v-btn>
    </v-layout>
  </pl-modal>
</template>

<script>
import PLModal from '@/components/Modal/PLModal'
import axios from 'axios'
import Preloader from '@/components/Preloader/Preloader'
import snack from '@/helpers/snack'
import fullName from '@/helpers/full_name'
import store from '@/store/index'
import { mapGetters } from 'vuex'
import moment from 'moment'

const CancelToken = axios.CancelToken

export default {
  name: 'authentication',
  components: {
    'pl-modal': PLModal,
    preloader: Preloader,
  },
  props: {
    opened: {
      required: true,
    },
  },
  data() {
    return {
      showAuthentication: false,
      getFingerPrint: false,
      checkFingerPrintIsActive: false,
      colorFingerIcon: '',
      cancelTokenParams: null,
      activeEmployer: {},
      units: [],
      localUnit: '',
      unitsLoaded: false,
      counterBadFingerPrint: 0,
      prevAuthenticationEmployerId: null,
    }
  },
  computed: {
    userUnitId() {
      return this.$store.getters.user?.unit_id
    },
    ...mapGetters(['user']),
  },
  methods: {
    changeUnit() {
      if (this.cancelTokenParams) this.cancelTokenParams()
      this.checkFingerPrint()
    },
    closeDialog() {
      this.showAuthentication = false
      this.getFingerPrint = false
      this.activeEmployer = {}
      this.$emit('closeAuthenticationModal')
    },
    getEmployerName(employer) {
      return fullName.by(employer)
    },
    async loadUnits() {
      // только студии
      const {
        data: { data },
      } = await axios.get(`${this.$config.server}/${this.$config.modules.crm.api.authentication.getMastersUnits}`, {
        params: {
          unit_id: this.userUnitId,
          date: moment().format('YYYY-MM-DD'),
        },
      })
      this.unitsLoaded = true
      this.units = data
      this.localUnit = this.userUnitId
    },
    checkFingerPrint() {
      if (this.getFingerPrint) return
      const unit = this.units.find(x => x.id === this.localUnit)
      const url = unit ? unit.settings.fpBaseUrl : 'https://fp.pilki.tech/'

      axios({
        method: 'get',
        url: `${url}avz/feature/?unit_id=${this.localUnit}`,
        // url: `http://localhost:8000/api/crm/test`,
        // timeout: 10000,
        cancelToken: new CancelToken(c => {
          this.cancelTokenParams = c
        }),
      })
        .then(response => {
          if (response.data.status !== 'success') {
            this.colorFingerIcon = 'red'
            this.checkFingerPrint()
          } else if (response.data.status === 'success') {
            if (this.prevAuthenticationEmployerId === response.data.employer_id) {
              return
            }

            this.prevAuthenticationEmployerId = response.data.employer_id
            this.colorFingerIcon = 'green'
            this.getFingerPrint = true
            store
              .dispatch('CHECK_IN_EMPLOYER', { employer_id: response.data.employer_id })
              .then(response => {
                this.activeEmployer = response.data.data.employer
              })
              .catch(e => {
                if (e.response.data.code == 1250) {
                  snack.add('Сотрудник не стоит в графике')
                }
              })
              .finally(() => {
                setTimeout(() => {
                  this.prevAuthenticationEmployerId = null
                }, 10000)
              })
          }
        })
        .catch(error => {
          if (error.message === 'bad fingerprint') {
            this.counterBadFingerPrint++
            if (this.counterBadFingerPrint < 20) {
              this.$notify({
                group: 'hasBottomNavigation',
                type: 'error',
                text: 'Отпечаток плохого качества. Попробуйте еще раз или приложите другой палец',
              })
            } else {
              this.$notify({
                group: 'hasBottomNavigation',
                type: 'error',
                text: 'Приложите палец под другим уклоном',
              })
              this.counterBadFingerPrint = 0
            }
          }
          if (error.message === 'no open device') {
            this.$notify({
              group: 'hasBottomNavigation',
              type: 'error',
              text: 'Проверьте подключение кабеля',
            })
          }
          this.colorFingerIcon = 'red'
          this.getFingerPrint = false
          if (!axios.isCancel(error)) {
            this.checkFingerPrint()
          }
        })
    },
    initialize() {
      if (!this.unitsLoaded) {
        this.loadUnits().then(() => {
          this.showAuthentication = true
        })
      } else {
        this.showAuthentication = true
      }
    },
    async refreshFingerprints() {
      try {
        await axios.post(`https://fp.pilki.tech/avz/force-update?unit_id=${this.localUnit}`)
      } catch {
        this.$notify({
          group: 'hasBottomNavigation',
          type: 'error',
          text: 'Ошибка обновления',
        })
      }
    },
  },
  watch: {
    opened(val) {
      if (val) {
        this.initialize()
      }
    },
    showAuthentication(val) {
      this.cancelTokenParams()

      if (val) {
        this.checkFingerPrint()
      } else {
        this.colorFingerIcon = ''
        this.getFingerPrint = false
      }
    },
  },
}
</script>
